import {AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//types
import {
	IOrganizationContact,
	IOrganizationContactResponse,
	IOrganizationContactsListRequest,
	IOrganizationContactsListResponse,
	IOrganizationContactsRequest,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';
import {ID} from '../constants';

class OrganizationContactService {
	static getContactsList = async (
		reqBody: IOrganizationContactsListRequest
	): Promise<AxiosResponse<IOrganizationContactsListResponse>> => orgAPI.post(API_URL.CONTACT_LIST, reqBody);

	static getContact = async (contactId: number): Promise<AxiosResponse<IOrganizationContact>> =>
		orgAPI.get(`${API_URL.CONTACT}/${contactId}`);

	static updateContact = async (
		contactId: number,
		reqBody: Omit<IOrganizationContact, typeof ID | 'added' | 'edited'>
	): Promise<AxiosResponse<IOrganizationContact>> => orgAPI.put(`${API_URL.CONTACT}/${contactId}`, reqBody);

	static deleteContact = async (contactId: number): Promise<AxiosResponse> =>
		orgAPI.delete(`${API_URL.CONTACT}/${contactId}`);

	static getExistingContactList = async (
		reqBody: IOrganizationContactsRequest
	): Promise<AxiosResponse<IOrganizationContactResponse[]>> => orgAPI.post(API_URL.CONTACT_LIST_GET_EXISTING, reqBody);

	static setContactList = async (reqBody: IOrganizationContactsRequest): Promise<AxiosResponse> =>
		orgAPI.post(API_URL.CONTACT, reqBody);
}

export {OrganizationContactService};
